import { reactive } from '@vue/composition-api'

export const KnowledgeSelectNote = (context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { knowledge } = store.state

  const state = reactive({
    isOpenHistoryTags: false
  })
  const close = () => {
    context.emit('closeKnowledgeSelectNote')
  }
  const submit = (id) => {
    store
      .dispatch('search/setNoteSearchParam', { id: id })
      .then(() => {
        context.emit('closeKnowledgeSelectNote')
        
        if (store.state.common.device === 'sp') {
          router.push({ name: 'SPNoteEdit', params: { note_id: id } })
        } else {
          router.push({ name: 'PCNoteList' })
        }
      })
  }

  return {
    knowledge,
    state,
    close,
    submit
  }
}
